/* eslint-disable max-len */
export const seoMain = {
  title:
    'Проектный маркет - купить готовый проект или скачать бесплатно BIM-модель на PlanDi',
  description:
    'Купить готовый проект или 3D модель используя сервис PlanDi. Лучшая экосистема инженерных решений.'
}

export const seoMainEn = {
  titleEn:
    'Project market - buy a ready-made project or download a free BIM model on PlanDi',
  descriptionEn:
    'Buy a finished project or 3D model using the PlanDi service. The best ecosystem of engineering solutions.'
}

export const seoModels = {
  title: 'BIM-модели - Все для проектировщика на Plandi (BIM, 3D-модели)',
  description:
    'В нашей библиотеке можно найти и скачать нужную вам 3D модель. Самый полный каталог!'
}

export const seoModelsEn = {
  titleEn:
    'BIM models - Everything for the designer on Plandi (BIM, 3D models)',
  descriptionEn:
    'In our library you can find and download the 3D model you need. The most complete catalog!'
}

export const projectsSeo = {
  title: 'Купить готовый проект или проектное решение на PlanDi',
  description:
    'Сервис PlanDi позволяет быстро купить готовый проект. Смотреть каталог готовых решений!'
}

export const projectsSeoEn = {
  titleEn: 'Buy a ready-made project or design solution on PlanDi',
  descriptionEn:
    'The PlanDi service allows you to quickly buy a finished project. View the catalog of ready-made solutions!'
}

export const goodsSeo = {
  title: 'Купить товар на PlanDi',
  description:
    'Сервис PlanDi позволяет быстро купить товар. Смотреть каталог товаров!'
}

export const goodsSeoEn = {
  titleEn: 'Buy a product on PlanDi',
  descriptionEn:
    'The PlanDi service allows you to quickly buy goods. View the product catalog!'
}
